import {Component, Input} from '@angular/core';
import {CartService} from "../../../core/services/cart.service";
import {Router} from "@angular/router";
import {ToastService} from "../../../core/services/toast.service";
import { Platform } from '@angular/cdk/platform';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent {
  @Input() product:any;
  @Input() cartEnabled: boolean = false;
  selectedItem = 0;
  wordLimit = 25;

  colorsWithCodes = {
    "black": '#000000',
    "green": '#008000',
    'graphite black': '#2F353B',
    'misty lavender': '#B4A7D6',
    'ice silver': '#D1D8E0',
    'any colour': '#B1A0A1',
    'lime green': '#32CD32',
    'glittery white': '#F7F7F7',
    'startail black': '#171717',
    'amber orange': '#FFBF00',
    'emerald green': '#50C878',
    'light blue': '#ADD8E6',
    "violet": '#8A2BE2',
    "white": '#FFFFFF',
    'midnight navy': '#003366',
    'dusk pink': '#D8A7B1',
    'starry black': '#1C1C1C',
    "purple": '#800080',
    "grey": '#808080',
    'charcoal black': '#36454F',
    "blue": '#0000FF',
    'copper teal': '#4A7B7F',
    'dull gold wine red': '#9B1B30',
    'classic black': '#1B1B1B',
    'rose gold': '#B76E79',
    "silver": '#C0C0C0',
    'active black': '#101010',
    'stary blue': '#1E3A5F',
    'davys green': '#555D50',
    'gunmetal black': '#2A3533'
  };
  viewSimilar: boolean = false;

  constructor(private cartService: CartService, private router: Router, private toast: ToastService, private platform: Platform) {
    this.wordLimit = !this.platform.ANDROID ? this.wordLimit : 35;
  }

  calculateDiscount(item: any) {
    if (item.mrp && item.mop) {
      const discount = Math.round(((item.mrp - item.mop) / item.mrp) * 100);
      return parseFloat(discount.toFixed(2))+'% off';
    }
    return 0;
  }

  addToCart(product:any) {
    let item = product.items[this.selectedItem];
    item['itemId'] = item.item_id;
    this.cartService.addToCart(item);
  }

  navigateURL(product: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/product/${product.catalogId}`]);
    });
    //this.router.navigateByUrl(`/product/${product.catalogId}`);
  }

  modifyTitle(title: string) {
    return (screen.width > 767 && title.length > this.wordLimit) ? title.substring(0, this.wordLimit)+'...' : title;
  }
}
